import React from "react";
import { useNavigate } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function StartCard({ onLater }) {
  const { s } = useS();
  const nav = useNavigate();
  return (
    <div className="beam p-[1px]" data-testid="home-start-card">
      <div className="rounded-[1.2rem] bg-[var(--lb-card)] p-6">
        <div className="w-12 h-12 rounded-2xl bg-neon/15 text-neon flex items-center justify-center"><Compass size={24} /></div>
        <h2 className="font-display font-black text-2xl sm:text-3xl leading-tight mt-4">{s("start_title")}</h2>
        <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-2">{s("start_sub")}</p>
        <Button onClick={() => nav("/app/start")} data-testid="home-start-cta" className="w-full sm:w-auto sm:px-8 mt-6 rounded-full h-14 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold text-base">
          {s("start_cta")} <ArrowRight size={18} className="ml-1.5" />
        </Button>
        <button onClick={onLater} data-testid="home-start-later" className="block w-full sm:w-auto sm:inline-block sm:ml-4 mt-2 min-h-[44px] text-sm text-[hsl(var(--muted-foreground))] hover:text-white transition-colors">
          {s("later")}
        </button>
      </div>
    </div>
  );
}
